import React, {
    useEffect,
    useState,
} from "react";

import toast from "react-hot-toast";

import API from "../../services/api";
import { Link, useNavigate } from "react-router-dom";
import {
    FaEdit,
    FaTrash,
    FaBan,
    FaCheckCircle,
    FaWallet,
    FaUser
} from "react-icons/fa";
import { hasPermission } from "../../utils/permission";

function Partners() {
    const [partners, setPartners] =
        useState([]);
    const navigate = useNavigate();

    const [page, setPage] =
        useState(1);

    const [pages, setPages] =
        useState(1);

    const [search, setSearch] = useState("");
    const [showWalletModal, setShowWalletModal] = useState(false);

    const [walletForm, setWalletForm] = useState({
        partner_id: "",
        partner_name: "",
        current_wallet: 0,
        amount: "",
        transaction_type: "deposit",
        wallet_type: "cash",
        remarks: ""
    });

    const openWalletModal = (partner) => {
        setWalletForm({
            partner_id: partner.id,
            partner_name: partner.name,
            current_wallet: partner.wallet,
            amount: "",
            transaction_type: "deposit",
            wallet_type: "cash",
            remarks: ""
        });

        setShowWalletModal(true);
    };

    const updateWallet = async () => {

        try {

            const token =
                localStorage.getItem("adminToken");

            const res =
                await API.put(
                    `/admin/partner/${walletForm.partner_id}/update-wallet`,
                    {
                        amount: walletForm.amount,
                        transaction_type:
                            walletForm.transaction_type,
                        wallet_type:
                            walletForm.wallet_type,
                        remarks:
                            walletForm.remarks
                    },
                    {
                        headers: {
                            Authorization:
                                `Bearer ${token}`
                        }
                    }
                );

            toast.success(res.data.message);

            setShowWalletModal(false);

            loadPartners();

        } catch (err) {

            toast.error(
                err.response?.data?.message ||
                "Something went wrong."
            );

        }

    };

    useEffect(() => {
        loadPartners();
    }, [page, search]);

    const loadPartners =
        async () => {
            try {
                const token =
                    localStorage.getItem(
                        "adminToken"
                    );

                const res =
                    await API.get(
                        `/admin/partners?page=${page}&search=${search}`,
                        {
                            headers: {
                                Authorization:
                                    `Bearer ${token}`,
                            },
                        }
                    );

                setPartners(
                    res.data.partners
                );

                setPages(
                    res.data.pages
                );
            } catch (err) {
                console.log(err);
            }
        };

    const toggleStatus =
        async (id) => {
            const token =
                localStorage.getItem(
                    "adminToken"
                );

            await API.put(
                `/admin/partner/${id}/status`,
                {},
                {
                    headers: {
                        Authorization:
                            `Bearer ${token}`,
                    },
                }
            );

            loadPartners();
        };

    const deletePartner =
        async (id) => {
            if (
                !window.confirm(
                    "Delete Partner?"
                )
            )
                return;

            const token =
                localStorage.getItem(
                    "adminToken"
                );

            await API.delete(
                `/admin/partner/${id}`,
                {
                    headers: {
                        Authorization:
                            `Bearer ${token}`,
                    },
                }
            );

            loadPartners();
        };



    return (
        <>

            <div>
                <div
                    className="flex align-center justify-between 
        mb-6"
                >
                    <h1
                        className="
        text-3xl
        md:text-4xl
        font-bold
        "
                    >
                        Partners
                    </h1>

                    {hasPermission("partner.add") && (
                        <Link
                            to="/admin/partner/add"
                            className="
                            bg-yellow-500
                            text-black
                            px-5
                            py-3
                            rounded-xl
                            font-semibold
                            "
                        >
                            + Add Partner
                        </Link>
                    )}

                </div>

                <input
                    placeholder="Search partner..."
                    value={search}
                    onChange={(e) =>
                        setSearch(
                            e.target.value
                        )
                    }
                    className="
        w-full
        md:max-w-md
        p-3
        mb-6
        rounded-xl
        bg-[#111]
        border
        border-yellow-500/20
        "
                />

                <div
                    className="
        bg-[#111]
        rounded-2xl
        overflow-hidden
        "
                >
                    <div
                        className="
          overflow-x-auto
          "
                    >
                        <table
                            className="
            min-w-[700px]
            w-full
            "
                        >
                            <thead>
                                <tr
                                    className="
                border-b
                border-yellow-500/20
                "
                                >
                                    <th className="p-4 text-left">
                                        Name
                                    </th>

                                    <th className="p-4 text-left">
                                        Phone
                                    </th>

                                    <th className="p-4 text-left">
                                        Email
                                    </th>

                                    <th className="p-4 text-left">
                                        Wallet
                                    </th>

                                    <th className="p-4 text-left">
                                        Status
                                    </th>

                                    <th className="p-4 text-left">
                                        Action
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                {partners.map(
                                    (partner) => (
                                        <tr
                                            key={partner.id}
                                            className="
                    border-b
                    border-yellow-500/10
                    "
                                        >
                                            <td className="p-4">
                                                {partner.name || "N/A"}
                                            </td>

                                            <td className="p-4">
                                                {partner.phone || "N/A"}
                                            </td>

                                            <td className="p-4">
                                                {partner.email || "N/A"}
                                            </td>

                                            <td className="p-4">
                                                {partner.wallet || 0}
                                            </td>

                                            <td className="p-4">
                                                <span
                                                    className={
                                                        partner.status ===
                                                            "active"
                                                            ? "text-green-500"
                                                            : "text-red-500"
                                                    }
                                                >
                                                    {partner.status}
                                                </span>
                                            </td>

                                            <td className="p-4">
                                                <div className="flex flex-wrap gap-2">

                                                    {hasPermission("partner.wallet_update") && (
                                                        <>
                                                            <button
                                                                onClick={() => openWalletModal(partner)}
                                                                className="
                                                        flex
                                                        items-center
                                                        gap-2
                                                        px-3
                                                        py-2
                                                        rounded-lg
                                                        bg-green-600
                                                        hover:bg-green-700
                                                        text-white
                                                        text-sm
                                                    "
                                                            >
                                                                <FaWallet />
                                                                Wallet
                                                            </button>
                                                        </>
                                                    )}

                                                    {hasPermission("partner.edit") && (
                                                        <>
                                                            <Link
                                                                to={`/admin/partner/edit/${partner.id}`}
                                                                className="
                                                            flex
                                                            items-center
                                                            gap-2
                                                            px-3
                                                            py-2
                                                            rounded-lg
                                                            bg-blue-600
                                                            hover:bg-blue-700
                                                            text-white
                                                            text-sm
                                                            font-medium
                                                            transition-all
                                                            "
                                                            >
                                                                <FaEdit />
                                                                Edit
                                                            </Link>

                                                            <button
                                                                onClick={() => toggleStatus(partner.id)}
                                                                className={`
                                                                flex
                                                                items-center
                                                                gap-2
                                                                px-3
                                                                py-2
                                                                rounded-lg
                                                                text-sm
                                                                font-medium
                                                                transition-all
                                                                ${partner.status === "active"
                                                                        ? "bg-orange-500 hover:bg-orange-600 text-white"
                                                                        : "bg-green-600 hover:bg-green-700 text-white"
                                                                    }
      `}
                                                            >
                                                                {partner.status === "active" ? (
                                                                    <>
                                                                        <FaBan />
                                                                        Block
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <FaCheckCircle />
                                                                        Unblock
                                                                    </>
                                                                )}
                                                            </button>
                                                        </>
                                                    )}

                                                    {hasPermission("partner.delete") && (
                                                        <button
                                                            onClick={() => deletePartner(partner.id)}
                                                            className="
                                                        flex
                                                        items-center
                                                        gap-2
                                                        px-3
                                                        py-2
                                                        rounded-lg
                                                        bg-red-600
                                                        hover:bg-red-700
                                                        text-white
                                                        text-sm
                                                        font-medium
                                                        transition-all
                                                        "
                                                        >
                                                            <FaTrash />
                                                            Delete
                                                        </button>
                                                    )}

                                                    <Link
                                                                to={`/admin/partner/${partner.id}`}
                                                                className="
                                                            flex
                                                            items-center
                                                            gap-2
                                                            px-3
                                                            py-2
                                                            rounded-lg
                                                            bg-blue-600
                                                            hover:bg-blue-700
                                                            text-white
                                                            text-sm
                                                            font-medium
                                                            transition-all
                                                            "
                                                            >
                                                                <FaUser />
                                                                Profile
                                                            </Link>

                                                </div>
                                            </td>
                                        </tr>
                                    )
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Pagination */}

                <div className="flex items-center gap-2 mt-6 flex-wrap">

                    <button
                        disabled={page === 1}
                        onClick={() => setPage(page - 1)}
                        className={`
      px-4 py-2 rounded-lg
      ${page === 1
                                ? "bg-[#111] opacity-50 cursor-not-allowed"
                                : "bg-[#111] hover:bg-yellow-500 hover:text-black"
                            }
    `}
                    >
                        Back
                    </button>

                    {Array.from(
                        { length: pages },
                        (_, i) => i + 1
                    )
                        .filter(
                            p =>
                                p === 1 ||
                                p === pages ||
                                (p >= page - 1 &&
                                    p <= page + 1)
                        )
                        .map((p, index, arr) => (
                            <React.Fragment key={p}>

                                {index > 0 &&
                                    arr[index - 1] !== p - 1 && (
                                        <span className="px-2">
                                            ...
                                        </span>
                                    )}

                                <button
                                    onClick={() => setPage(p)}
                                    className={`
            px-4 py-2 rounded-lg
            ${page === p
                                            ? "bg-yellow-500 text-black"
                                            : "bg-[#111]"
                                        }
          `}
                                >
                                    {p}
                                </button>

                            </React.Fragment>
                        ))}

                    <button
                        disabled={page === pages}
                        onClick={() => setPage(page + 1)}
                        className={`
      px-4 py-2 rounded-lg
      ${page === pages
                                ? "bg-[#111] opacity-50 cursor-not-allowed"
                                : "bg-[#111] hover:bg-yellow-500 hover:text-black"
                            }
    `}
                    >
                        Next
                    </button>

                </div>
                {
                    showWalletModal && (

                        <div className="fixed inset-0 z-50 overflow-y-auto bg-black/70">

                            <div className="min-h-screen flex items-start justify-center py-10 px-4">

                                <div
                                    className="
                w-full
                max-w-2xl
                bg-[#111]
                border
                border-yellow-500/20
                rounded-3xl
                shadow-2xl
                my-8
            "
                                >

                                    <div className="p-6 border-b border-yellow-500/20">

                                        <h2 className="text-2xl font-bold text-yellow-400">
                                            Update Partner Wallet
                                        </h2>

                                    </div>

                                    <div className="px-6 pt-6 space-y-5 max-h-[70vh] overflow-y-auto">

                                        <div>

                                            <label className="text-gray-400 text-sm">
                                                Partner Name
                                            </label>

                                            <input
                                                readOnly
                                                value={walletForm.partner_name}
                                                className="w-full mt-2 p-3 rounded-xl bg-black border border-yellow-500/20"
                                            />

                                        </div>

                                        <div>
                                            <label className="text-sm text-gray-400">
                                                Current Wallet
                                            </label>

                                            <div className="mt-2 bg-green-500/10 border border-green-500 rounded-xl p-4">
                                                <p className="text-xs text-gray-400">
                                                    Available Balance
                                                </p>

                                                <h2 className="text-3xl font-bold text-green-400">
                                                    ₹ {Number(walletForm.current_wallet).toLocaleString()}
                                                </h2>
                                            </div>
                                        </div>

                                        <div>

                                            <label className="text-gray-400 text-sm">
                                                Amount
                                            </label>

                                            <input
                                                type="number"
                                                value={walletForm.amount}
                                                onChange={(e) =>
                                                    setWalletForm({
                                                        ...walletForm,
                                                        amount: e.target.value
                                                    })
                                                }
                                                className="w-full mt-2 p-3 rounded-xl bg-black border border-yellow-500/20"
                                            />

                                        </div>

                                        <div>
                                            <label className="text-sm text-gray-400 block mb-2">
                                                Transaction Type
                                            </label>

                                            <div className="grid grid-cols-2 gap-4">

                                                <button
                                                    type="button"
                                                    onClick={() =>
                                                        setWalletForm({
                                                            ...walletForm,
                                                            transaction_type: "deposit"
                                                        })
                                                    }
                                                    className={`p-4 rounded-xl font-semibold transition
            ${walletForm.transaction_type === "deposit"
                                                            ? "bg-green-600 text-white"
                                                            : "bg-[#222]"
                                                        }`}
                                                >
                                                    + Deposit
                                                </button>

                                                <button
                                                    type="button"
                                                    onClick={() =>
                                                        setWalletForm({
                                                            ...walletForm,
                                                            transaction_type: "withdraw"
                                                        })
                                                    }
                                                    className={`p-4 rounded-xl font-semibold transition
            ${walletForm.transaction_type === "withdraw"
                                                            ? "bg-red-600 text-white"
                                                            : "bg-[#222]"
                                                        }`}
                                                >
                                                    − Withdraw
                                                </button>

                                            </div>
                                        </div>

                                        <div>
                                            <label className="text-sm text-gray-400 block mb-2">
                                                Payment Wallet
                                            </label>

                                            <div className="grid grid-cols-3 gap-4">

                                                {[
                                                    { value: "cash", label: "💵 Cash" },
                                                    { value: "bank", label: "🏦 Bank" },
                                                    { value: "edt", label: "💳 EDT" }
                                                ].map((item) => (

                                                    <button
                                                        key={item.value}
                                                        type="button"
                                                        onClick={() =>
                                                            setWalletForm({
                                                                ...walletForm,
                                                                wallet_type: item.value
                                                            })
                                                        }
                                                        className={`p-4 rounded-xl border transition
                ${walletForm.wallet_type === item.value
                                                                ? "border-yellow-500 bg-yellow-500/20"
                                                                : "border-[#333] bg-[#181818]"
                                                            }`}
                                                    >
                                                        {item.label}
                                                    </button>

                                                ))}

                                            </div>
                                        </div>

                                        <div>

                                            <label className="text-gray-400 text-sm">
                                                Remarks
                                            </label>

                                            <textarea
                                                rows="3"
                                                value={walletForm.remarks}
                                                onChange={(e) =>
                                                    setWalletForm({
                                                        ...walletForm,
                                                        remarks: e.target.value
                                                    })
                                                }
                                                className="w-full mt-2 p-3 rounded-xl bg-black border border-yellow-500/20"
                                            />

                                        </div>

                                        <div className="sticky bottom-0 bg-[#111] border-t border-yellow-500/20 p-6 flex justify-end gap-4">

                                            <button
                                                onClick={() => setShowWalletModal(false)}
                                                className="px-6 py-3 rounded-xl bg-gray-700 hover:bg-gray-600"
                                            >
                                                Cancel
                                            </button>

                                            <button
                                                onClick={updateWallet}
                                                className="px-8 py-3 rounded-xl bg-yellow-500 hover:bg-yellow-400 text-black font-bold"
                                            >
                                                Update Wallet
                                            </button>

                                        </div>

                                    </div>

                                </div>

                            </div>
                        </div>

                    )
                }
            </div>
        </>
    );
}

export default Partners;